import { useState, useRef, lazy } from 'react';
import {
    BlockWrapper,
    ChildrenBlock,
    defineBlock,
    smartProps,
    useBlockEffect,
    useInspectorControl,
} from '@smartfire/js-block-engine';
import style from './block.module.scss';
import clsx from 'clsx';

const Inspector = lazy(() => import('./inspector'));

const Block = ({ name, label, choices, type, showLabel, parentName = null, formErrors, setFormErrors }) => {
    useInspectorControl(Inspector);
    const [choiceValue, setChoiceValue] = useState(choices[0].name);
    const [choiceId] = useState(`${label.replace(/ /g, '_').toLowerCase()}_${Math.floor(Math.random() * 100)}`);
    const choicesRef = useRef(null);
    const isFirstChoiceGroup = choices[0].type === 'group';
    const id = `formulaide_choices_${choiceId}`;
    let finalName = 'root_field';

    if (parentName) {
        if (name) {
            finalName = `${parentName}:${name}`;
        } else {
            finalName = parentName;
        }
    } else if (name) {
        finalName = name;
    }

    useBlockEffect(() => {
        const groups = document.querySelectorAll(`div[id^="formulaide_group_${choiceId}"]`);

        if (groups.length > 0) {
            groups.forEach((group) => {
                if (group.id !== `formulaide_group_${choiceId}_${choiceValue}`) {
                    group.style.display = 'none';
                } else {
                    group.style.display = 'block';
                }
            });
        }
    }, [choiceValue, choiceId]);

    return (
        <BlockWrapper.Div id={id} className={clsx(style.choices, style[type])} ref={choicesRef}>
            {showLabel && label && <label htmlFor={id}>{label}</label>}
            {type === 'select' ? (
                <select id={id} name={finalName} value={choiceValue} onChange={(e) => setChoiceValue(e.target.value)}>
                    {choices.map((choice) => (
                        <option key={choice.name} value={choice.name}>
                            {choice.label}
                        </option>
                    ))}
                </select>
            ) : (
                <div className={style.radios}>
                    {choices.map((choice, index) => (
                        <div className={style.radioGroup} key={choice.name}>
                            <label htmlFor={`${id}_${index}`}>{choice.label}</label>
                            <input
                                id={`${id}_${index}`}
                                name={finalName}
                                value={choice.name}
                                checked={choiceValue === choice.name}
                                type={'radio'}
                                onChange={(e) => setChoiceValue(e.target.value)}
                            />
                        </div>
                    ))}
                </div>
            )}

            <ChildrenBlock
                gutenbergEditorConfig={{
                    orientation: 'vertical',
                }}
                className={clsx(style.groups, !isFirstChoiceGroup && style.noGroup)}
                childrenProps={{
                    parentName: finalName !== 'root_field' ? finalName : null,
                    choiceId: choiceId,
                    formErrors: formErrors,
                    setFormErrors: setFormErrors,
                }}
            />
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block: Block,
    smartProps: {
        name: smartProps.string.withDefault(''),
        label: smartProps.string.withDefault(''),
        choices: smartProps.array.withDefault([]),
        type: smartProps.string.withDefault('select'),
        showLabel: smartProps.bool.withDefault(true),
    },
    setup: {
        title: 'Choix',
        parent: ['smartfire/formulaide'],
    },
});
